/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UploadOpenAPIv3AssetSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UploadOpenAPIv3AssetSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UploadOpenAPIv3AssetSecurity = {
  option1?: UploadOpenAPIv3AssetSecurityOption1 | undefined;
  option2?: UploadOpenAPIv3AssetSecurityOption2 | undefined;
};

export type UploadOpenAPIv3AssetRequest = {
  contentLength: number;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  requestBody: ReadableStream<Uint8Array> | Blob | ArrayBuffer | Uint8Array;
};

/** @internal */
export type UploadOpenAPIv3AssetSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UploadOpenAPIv3AssetSecurityOption1$outboundSchema: z.ZodMiniType<
  UploadOpenAPIv3AssetSecurityOption1$Outbound,
  UploadOpenAPIv3AssetSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function uploadOpenAPIv3AssetSecurityOption1ToJSON(
  uploadOpenAPIv3AssetSecurityOption1: UploadOpenAPIv3AssetSecurityOption1,
): string {
  return JSON.stringify(
    UploadOpenAPIv3AssetSecurityOption1$outboundSchema.parse(
      uploadOpenAPIv3AssetSecurityOption1,
    ),
  );
}

/** @internal */
export type UploadOpenAPIv3AssetSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UploadOpenAPIv3AssetSecurityOption2$outboundSchema: z.ZodMiniType<
  UploadOpenAPIv3AssetSecurityOption2$Outbound,
  UploadOpenAPIv3AssetSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function uploadOpenAPIv3AssetSecurityOption2ToJSON(
  uploadOpenAPIv3AssetSecurityOption2: UploadOpenAPIv3AssetSecurityOption2,
): string {
  return JSON.stringify(
    UploadOpenAPIv3AssetSecurityOption2$outboundSchema.parse(
      uploadOpenAPIv3AssetSecurityOption2,
    ),
  );
}

/** @internal */
export type UploadOpenAPIv3AssetSecurity$Outbound = {
  Option1?: UploadOpenAPIv3AssetSecurityOption1$Outbound | undefined;
  Option2?: UploadOpenAPIv3AssetSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UploadOpenAPIv3AssetSecurity$outboundSchema: z.ZodMiniType<
  UploadOpenAPIv3AssetSecurity$Outbound,
  UploadOpenAPIv3AssetSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UploadOpenAPIv3AssetSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UploadOpenAPIv3AssetSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function uploadOpenAPIv3AssetSecurityToJSON(
  uploadOpenAPIv3AssetSecurity: UploadOpenAPIv3AssetSecurity,
): string {
  return JSON.stringify(
    UploadOpenAPIv3AssetSecurity$outboundSchema.parse(
      uploadOpenAPIv3AssetSecurity,
    ),
  );
}

/** @internal */
export type UploadOpenAPIv3AssetRequest$Outbound = {
  "Content-Length": number;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Gram-Session"?: string | undefined;
  RequestBody: ReadableStream<Uint8Array> | Blob | ArrayBuffer | Uint8Array;
};

/** @internal */
export const UploadOpenAPIv3AssetRequest$outboundSchema: z.ZodMiniType<
  UploadOpenAPIv3AssetRequest$Outbound,
  UploadOpenAPIv3AssetRequest
> = z.pipe(
  z.object({
    contentLength: z.int(),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    requestBody: z.union([
      z.custom<ReadableStream<Uint8Array>>(x => x instanceof ReadableStream),
      z.custom<Blob>(x => x instanceof Blob),
      z.custom<ArrayBuffer>(x => x instanceof ArrayBuffer),
      z.custom<Uint8Array>(x => x instanceof Uint8Array),
    ]),
  }),
  z.transform((v) => {
    return remap$(v, {
      contentLength: "Content-Length",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      gramSession: "Gram-Session",
      requestBody: "RequestBody",
    });
  }),
);

export function uploadOpenAPIv3AssetRequestToJSON(
  uploadOpenAPIv3AssetRequest: UploadOpenAPIv3AssetRequest,
): string {
  return JSON.stringify(
    UploadOpenAPIv3AssetRequest$outboundSchema.parse(
      uploadOpenAPIv3AssetRequest,
    ),
  );
}
